import axios from 'axios'

export const http = axios.create({
  timeout: 40000
})

export default async ({ Vue, store }) => {
  http.interceptors.request.use(config => {
    config.headers = {
      ...config.headers
    }

    return config
  })

  Vue.prototype.$http = http
}
